import { Chip } from '@mui/material';

/**
 * Renders "•••• set" when the server returned has_client_secret=true,
 * otherwise "not set". Never receives a real secret value.
 */
export function SecretBadge({ hasSecret }: { hasSecret: boolean }) {
  return (
    <Chip
      size="small"
      variant="outlined"
      color={hasSecret ? 'success' : 'warning'}
      label={hasSecret ? '•••• set' : 'not set'}
      aria-label={hasSecret ? 'Client secret is set' : 'Client secret not set'}
    />
  );
}
